// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"2b6ad0c9","470":"df55bd7a","556":"c23122f0"}[chunkId] + ".chunk.js";
};